module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-xs-left"
  }, [_c('h3', {
    staticClass: "modal__title"
  }, [_vm._v(_vm._s(_vm.$t('ARE_YOU_UP_TO_DATE')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('VERY_IMPORTANT_FOR_BRASTER')))])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                " + _vm._s(_vm.$t('UP_TO_DATE_1')) + "\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n                " + _vm._s(_vm.$t('UP_TO_DATE_2')) + "\n            ")]), _vm._v(" "), _c('li', [_vm._v("\n                " + _vm._s(_vm.$t('UP_TO_DATE_3')) + "\n            ")])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('ARE_YOU_UP_TO_DATE_2')))]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg",
    on: {
      "click": function($event) {
        return _vm.$emit('gotomydata')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('NO_I_WANT_TO_CHECK')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('YES')) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-050571ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/are-you-up-to-date.vue
// module id = 1155
// module chunks = 0